import React, { Component } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { doubleQuote } from '../../../../helpers/html';
import { api } from '../../../api';
import { getUserDisplayName } from '../../Users';

export class DeleteShare extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      showLoading: false,
    };
  }

  deleteStoriesAction() {
    const {
      onHide,
      obj,
      storyID,
      onError,
    } = this.props;

    this.setState({ showLoading: true });
    onHide();
    api.delete(`v1/stories/${storyID}/share/${obj.id}`)
      .then(() => onHide())
      .catch((error) => onError(error.response.data.error));
  }

  render() {
    const { obj, onHide } = this.props;
    const { showLoading } = this.state;

    return (
      <Modal
        {...this.props}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        className="zIndexModal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Delete User:
            <span>
              {doubleQuote}
              {getUserDisplayName(obj)}
              {doubleQuote}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-center">
            Do you really want to delete the user?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="reset"
            variant="secondary"
            onClick={onHide}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            onClick={() => this.deleteStoriesAction()}
          >
            {showLoading && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            )}
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
